// ** Icon Cache & Memoization
import { getIconData } from "../data";

// #####################################################

const iconCache = new Map();
const CACHE_SIZE_LIMIT = 50;

/**
 * Obsługa cache dla ikon
 */
export const getCachedIconData = (iconName, variant = "solid") => {
	const cacheKey = `${iconName}:${variant}`;

	if (iconCache.has(cacheKey)) {
		return iconCache.get(cacheKey);
	}

	const iconData = getIconData(iconName, variant);

	if (iconCache.size >= CACHE_SIZE_LIMIT) {
		const firstKey = iconCache.keys().next().value;
		iconCache.delete(firstKey);
	}

	iconCache.set(cacheKey, iconData);

	return iconData;
};

// #####################################################

/**
 * Preload critical icons
 */
export const preloadCriticalIcons = (criticalIcons = []) => {
	criticalIcons.forEach(({ name, variant = "solid" }) => {
		getCachedIconData(name, variant);
	});
};

// #####################################################

export default getCachedIconData;
